import { createTheme, alpha } from '@mui/material/styles'
import { grey } from '@mui/material/colors'

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    grey: true
  }
}

declare module '@mui/material' {
  interface Color {
    main: string
    dark: string
  }
}

const basicTheme = createTheme({
  palette: {
    primary: {
      main: '#06A9F4'
    },
    error: {
      main: '#F44336'
    },
    warning: {
      main: '#F5E45D'
    },
    background: {
      default: '#FFF'
    },
    grey: {
      main: grey[300],
      dark: grey[400]
    }
  },
  typography: {
    fontFamily: "'Rubik', 'Helvetica', 'Arial', sans-serif"
  }
})

const theme = createTheme(basicTheme, {
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            color: basicTheme.palette.common.white
          }
        },
        {
          props: { variant: 'contained', color: 'grey' },
          style: {
            color: basicTheme.palette.getContrastText(basicTheme.palette.grey[300])
          }
        },
        {
          props: { variant: 'outlined', color: 'grey' },
          style: {
            color: basicTheme.palette.text.primary,
            borderColor: basicTheme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
            '&.Mui-disabled': {
              border: `1px solid ${basicTheme.palette.action.disabledBackground}`
            },
            '&:hover': {
              borderColor: basicTheme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
              backgroundColor: alpha(basicTheme.palette.text.primary, basicTheme.palette.action.hoverOpacity)
            }
          }
        },
        {
          props: { color: 'grey', variant: 'text' },
          style: {
            color: basicTheme.palette.text.primary,
            '&:hover': {
              backgroundColor: alpha(basicTheme.palette.text.primary, basicTheme.palette.action.hoverOpacity)
            }
          }
        }
      ]
    }
  }
})

export default theme
